var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "switcher" }, [
    _c(
      "button",
      {
        staticClass: "switcher__btn left",
        class: { active: _vm.isLeftActive },
        on: { click: _vm.onLeftClick },
      },
      [_vm._t("leftValue")],
      2
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "switcher__btn right",
        class: {
          active: !_vm.isLeftActive,
          disabled: _vm.disabled || !_vm.auth,
        },
        on: { click: _vm.onRightClick },
      },
      [_vm._t("rightValue")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }